"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInFormView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const CommonComponents_1 = require("./CommonComponents");
const PasswordReminder = (0, app_1.styled)(app_1.Link) `
  text-align: center;
  color: ${(theme) => theme.colors.gray};
  margin: ${(theme) => theme.spacing.small} 0;
  display: block;
`;
const SignUpWrap = app_1.styled.span `
  text-align: center;
  margin-top: ${(theme) => theme.spacing.small};
  font-size: 0.8125rem;
  letter-spacing: 0.025rem;
`;
const SignUpLink = (0, app_1.styled)(app_1.Link) `
  font-weight: 700;
  font-size: inherit;
  letter-spacing: inherit;
`;
function SignInFormView({ handleSubmit, inputProps = {}, submitProps = {}, className, }) {
    const signUpPath = (0, app_1.useContextPath)('signUp');
    const forgotPasswordPath = (0, app_1.useContextPath)('forgotPassword') || '/password';
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(CommonComponents_1.StyledForm, Object.assign({ className: className, onSubmit: handleSubmit }, { children: [(0, jsx_runtime_1.jsx)(CommonComponents_1.StyledTextInput, Object.assign({ label: t('label.email'), name: "email" }, inputProps.email, { bottomPadding: true })), (0, jsx_runtime_1.jsx)(CommonComponents_1.StyledTextInput, Object.assign({ label: t('label.password'), name: "password", type: "password" }, inputProps.password, { bottomPadding: true })), (0, jsx_runtime_1.jsx)(PasswordReminder, Object.assign({ href: forgotPasswordPath }, { children: t('info.forgotPassword') })), (0, jsx_runtime_1.jsx)(CommonComponents_1.StyledSubmit, Object.assign({}, submitProps, { children: t('label.logIn') })), (0, jsx_runtime_1.jsxs)(SignUpWrap, { children: [t('info.NoAccountQuestion'), ' ', (0, jsx_runtime_1.jsx)(SignUpLink, Object.assign({ href: signUpPath }, { children: t('info.createAccount') }))] })] })));
}
exports.SignInFormView = SignInFormView;
